import { getCurationsOrderList } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  GetCurationsOrderListServiceRequest,
  GetCurationsOrderListServiceResponse,
} from './get-curations-order-list.dto';
import { GetCurationsOrderListServiceResponseSchema } from './get-curations-order-list.dto';

export const getCurationsOrderListService = withServiceErrorCapture(
  lazyPipe(
    async (
      request?: GetCurationsOrderListServiceRequest,
    ): Promise<GetCurationsOrderListServiceResponse> => {
      const response = await getCurationsOrderList(request);

      if (response.meta?.result === 'FAIL') {
        throw new Error(response.meta?.message ?? '큐레이션 목록 순서 조회에 실패했습니다.');
      }

      return {
        curations: response.data.curations.map((c) => ({
          curationId: c.id,
          title: c.title,
          ordNo: c.ordNo,
          type: c.type as 'GOODS' | 'SNAP2' | undefined,
        })),
      };
    },
    validateServiceResponse(GetCurationsOrderListServiceResponseSchema),
  ),
);
